import Cookies from "universal-cookie";
import { getByToken } from "../../../controllers/pessoa";

export const GetToken = () => {
    const cookies = new Cookies();
    return cookies.get("User-Token");
};

export const GetUserInfo = async () => {
    const cookies = new Cookies();
    const token = cookies.get("User-Token");

    const { codigo, nome } = await getByToken(token).then((response) => {
        const { itens } = JSON.parse(response.body);
        return itens;
    });

    return { id: codigo, nome };
};
